















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { EventModel, InjectionEventReason } from "@/models/event";

@Component({})
export class Injection extends Vue {
  @Prop({ required: true })
  event!: EventModel;

  @Prop()
  disabled!: boolean;

  get formConfig() {
    return {
      meta: {
        reason: {
          label: this.$t("event.fields.reason"),
          disabled: this.disabled,
          items: Object.entries(InjectionEventReason).map(([key, value]) => ({
            text: this.$t(`event.values.injectionReason.${value}`),
            value
          }))
        }
      }
    };
  }
}
export default Injection;
